__turbopack_context__.v({
  "normalWrapper": "BildeKollasj-module__FcZFHW__normalWrapper",
  "twoImageWrapper": "BildeKollasj-module__FcZFHW__twoImageWrapper",
});
